import StudentPasswordReset from "../views/schooladmin/StudentPasswordReset";
import StudentPasswordResetProjection from "../views/schooladmin/StudentPasswordResetProjection";

export default [
	{
		path: "/schooladmin/student_password_reset",
		meta: { requiresStudentPasswordReset: true, requiresLoggedIn: true },
		components: {
			content: StudentPasswordReset
		}
	},
	{
		path: "/schooladmin/student_password_reset_projection",
		meta: { requiresCoordinatorProjectionPasswordReset: true, requiresLoggedIn: true },
		components: {
			content: StudentPasswordResetProjection
		}
	}
];
